<template>
  <div class="notice-box">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "NoticeBox",
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.notice-box {
  border-radius: 10px;
  padding: 20px;
  &.-margin-md {
    margin-bottom: 40px;
    @include mq-up(md) {
      margin-bottom: 60px;
    }
  }
  :deep(.notice-header) {
    margin-bottom: 10px;
    font-weight: bold;
  }
  @include mq-up(md) {
    padding: 30px;
    :deep(.notice-header) {
      margin-bottom: 15px;
    }
  }
  &.-success {
    text-align: center;
    background-color: $success;
  }
  &.-cancel {
    text-align: center;
    background-color: $light;
  }
  &.-error {
    text-align: center;
    background-color: $warning;
  }
  &.-alert {
    text-align: left;
    background-color: $warning;
    border: 1px solid $danger;
    :deep(.notice-body) {
      color: $danger;
    }
  }
  &.-point {
    text-align: left;
    background-color: $success;
  }
}
</style>
